export const iconFontAwesomeCommunicationFaceSmile = (
	<i className="fa-solid fa-face-smile"></i>
);
